module.exports = __webpack_public_path__ + "img/1.cbdb8d04.png";